import * as React from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import MuiDrawer from "@mui/material/Drawer";
import Box from "@mui/material/Box";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MenuIcon from "@mui/icons-material/Menu";
import Img from "../../images/logo 01.png";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import Avtr from "../../images/avatar.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import ProfileImg from "../../images/avatar.png";
import { mainListItems, secondaryListItems } from "../dashboard/listItems";
import NotificationMenu from "../dashboard/notification";
import SearchBox from "../dashboard/searchbox";
import SettingForm from "./settingForm";
import ApiTable from "./apiTable";
import { useNavigate, Link } from "react-router-dom";
import DashboardDrawer from "../drawer/drawer";
import ChangeProfilePicModal from "./modals/profilePicModal";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { setAuthToken } from "../../utils/setAuthToken";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const settings = ["Profile", "Wallet", "Dashboard", "Logout"];

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  "& .MuiDrawer-paper": {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
export default function Settings() {
  const [open, setOpen] = React.useState(true);
  const [image, setImage] = React.useState("https://blockpaystorage.s3.ap-southeast-1.amazonaws.com/logo.png");
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const toggleDrawer = () => {
    setOpen(!open);
  };
  const handleMainLogoClick = () => {
    navigate("/");
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  // API Call for image
  const getMerchantDetails = (e) => {
    handleOpenbd();
    setAuthToken(localStorage.getItem("jwtToken"));
    axios
      .get("https://api.blockpay.co.za/merchant/getMerchantDetails", {})
      .then((res) => {
        console.log(res);
        if (res.data.profilepic !== null) {
          setImage(res.data.profilepic);
        }
        handleClosebd();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
        setTimeout(() => {
          handleClosebd();
        }, 2000);

        if (err.response.data.message === "Unauthorized!") {
          axios
            .post("https://api.blockpay.co.za/auth/refreshToken", {
              refreshToken: localStorage.getItem("refreshToken"),
            })
            .then((res) => {
              console.log(res);
              localStorage.setItem("jwtToken", res.data.accessToken);
              setTimeout(() => {
                window.location.reload();
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              localStorage.clear();
              window.location.reload();
            });
        }
      });
  };

  //backdrop usestates
  const [openbackdrop, setOpenbackdrop] = React.useState(false);
  const handleClosebd = () => {
    setOpenbackdrop(false);
  };
  const handleOpenbd = () => {
    setOpenbackdrop(true);
  };
  const navigate = useNavigate();

  const handleNavigation = (setting) => {
    // Navigate to the appropriate route based on the clicked setting
    if (setting === "Profile") {
      navigate("/setting", { replace: true });
    } else if (setting === "Wallet") {
      navigate("/wallet", { replace: true });
    } else if (setting === "Dashboard") {
      navigate("/dashboard", { replace: true });
    } else if (setting === "Logout") {
      localStorage.clear();
      window.location.reload();
    }
  };
  // Modal use State
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    // window.location.reload();
  };
  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 600) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    }
    window.addEventListener("resize", handleResize);
    // getMerchantDetails();
  });
  React.useEffect(()=>{getMerchantDetails();},[]);
  return (
    <ThemeProvider theme={defaultTheme}>
      <ToastContainer />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openbackdrop}
        onClick={handleClosebd}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          position="absolute"
          open={open}
        >
          <Toolbar
            sx={{
              pr: "24px", // keep right padding when drawer closed
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: "36px",
                color: "black",
                ...(open && { display: "none" }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="body1"
              color="inherit"
              noWrap
              sx={{
                flexGrow: 1,
                textAlign: "left",
                color: "black",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              <span>Welcome {localStorage.getItem("name")}!</span>
              <Typography
                component="h1"
                variant="caption"
                color="inherit"
                noWrap
                sx={{
                  flexGrow: 1,
                  textAlign: "left",
                  color: "grey",
                  fontSize: "12px",
                  position: "relative",
                  top: "-0.3rem",
                }}
              >
                Hope you are healthy and happy today...
              </Typography>
            </Typography>
            <Box sx={{ display: "flex" }}>
              <SearchBox />
              {/* //Notification Dialog code */}
              <NotificationMenu />
              <Box sx={{ flexGrow: 0 }}>
                <Tooltip title="Open settings">
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar alt="Remy Sharp" src={Avtr} />
                    <KeyboardArrowDownIcon />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  {settings.map((setting) => (
                    <MenuItem
                      key={setting}
                      onClick={() => handleNavigation(setting)}
                    >
                      <Typography textAlign="center">{setting}</Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
        <DashboardDrawer />
        <Drawer
          sx={{ display: { xs: "none", sm: "none", md: "block" } }}
          variant="permanent"
          open={open}
        >
          <Toolbar
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: [1],
            }}
          >
            <Box
              component="img"
              sx={{
                height: "38px",
              }}
              alt="The house from the offer."
              style={{ cursor: "pointer" }}
              onClick={handleMainLogoClick}
              src={Img}
            />
          </Toolbar>
          <Divider />
          <List component="nav">
            {mainListItems}
            <Divider sx={{ my: 1 }} />
            {secondaryListItems}
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: "#F5F5F5",
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Container
            maxWidth="false"
            sx={{ px: "24px!important", pt: "30px", paddingBottom: "20px" }}
          >
            <Box
              sx={{
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Typography
                sx={{
                  fontWeight: "600",
                  fontSize: "1.125rem",
                  mb: "3rem",
                  "@media (max-width:580px)": { mb: "2rem" },
                }}
              >
                Edit Profile
              </Typography>
            </Box>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Grid item sx={{mb:"1rem"}} sm={12} md={12} lg={6}>
                <Box
                  component="img"
                  src={image}
                  sx={{
                    height: "27.5rem",
                    width: "27.5rem",
                    mb: "0.7rem",
                    borderRadius: "50%",
                    "@media (max-width:580px)": {
                      height: "18rem!important",
                      width: "18rem",
                    },
                  }}
                />
                <ChangeProfilePicModal
                  open={openModal}
                  onClose={handleCloseModal}
                />
                <Typography
                  sx={{
                    color: "#05B2FF",
                    fontWeight: "500",
                    fontSize: "1.125rem",
                    mb: "1.5rem",
                    textDecoration: "none",
                  }}
                  component={Link}
                  onClick={handleOpenModal}
                >
                  Change Profile
                </Typography>
              </Grid>
              <Grid item sm={12} md={12} lg={6}>
                <SettingForm />
              </Grid>
              <Grid
                item
                sm={12}
                md={12}
                lg={12}
                sx={{
                  border: "solid 1px rgb(173, 171, 171)",
                  borderRadius: "15px",
                  padding: "0.7rem 1.5rem",
                }}
              >
                <ApiTable />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
}
